import { render, staticRenderFns } from "./TypeServiceList.vue?vue&type=template&id=4fa66b6c&scoped=true"
import script from "./TypeServiceList.vue?vue&type=script&lang=js"
export * from "./TypeServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa66b6c",
  null
  
)

export default component.exports